import { apiRequest } from './client';

export function fetchProcurementBatches(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/procurement${query ? `?${query}` : ''}`, token);
}

export function fetchProcurementBatchSummaries(token, params = {}) {
  const query = new URLSearchParams({ ...params, summaries: '1' }).toString();
  return apiRequest(`/admin/procurement?${query}`, token);
}

export function importUnshippedToProcurement(token) {
  return apiRequest('/admin/procurement/import-unshipped', token, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function createProcurementBatch(token, lines, name) {
  return apiRequest('/admin/procurement', token, {
    method: 'POST',
    body: JSON.stringify({ lines, name }),
  });
}

export function updateProcurementStatus(token, id, status) {
  return apiRequest('/admin/procurement', token, {
    method: 'PUT',
    body: JSON.stringify({ id, status }),
  });
}

export function updateProcurementBatch(token, id, { status, name, lines }) {
  return apiRequest('/admin/procurement', token, {
    method: 'PUT',
    body: JSON.stringify({ id, status, name, lines }),
  });
}

export function setProcurementLineConfirmed(
  token,
  batchId,
  lineId,
  { confirmed, clearBuyFields = false, purchasePrice = null } = {}
) {
  return apiRequest('/admin/procurement', token, {
    method: 'PUT',
    body: JSON.stringify({
      id: batchId,
      confirmLine: { lineId, confirmed, clearBuyFields, purchasePrice },
    }),
  });
}

export function deleteProcurementBatch(token, id) {
  return apiRequest('/admin/procurement', token, {
    method: 'DELETE',
    body: JSON.stringify({ id }),
  });
}

export function clearProcurementBatches(token) {
  return apiRequest('/admin/procurement', token, {
    method: 'DELETE',
  });
}

export function lookupHawbByTracking(token, trackingNumber) {
  return apiRequest('/admin/procurement/lookup-hawb', token, {
    method: 'POST',
    body: JSON.stringify({ trackingNumber }),
  });
}

export function fetchProcurementLineRemarkHistory(token, lineId) {
  return apiRequest(`/admin/procurement/lines/${lineId}/remark-history`, token);
}

export function fetchRecentProcurementRemarkHistory(token, params = {}) {
  const query = new URLSearchParams();
  if (params.orderId) query.set('orderId', params.orderId);
  if (params.limit != null) query.set('limit', String(params.limit));
  const qs = query.toString();
  return apiRequest(`/admin/procurement/remark-history${qs ? `?${qs}` : ''}`, token);
}
